import Reflux from 'reflux';
import FullScreenModalActions from 'flux/actions/FullScreenModalActions';
import Immutable from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';
import PopoverActions from 'flux/actions/PopoverActions';
import keyBinder from 'shared/lib/keyBinder';

/**
 * ModalStore
 *
 * Keeps track of modal visibility
 *
 */
export default Reflux.createStore({
  listenables: [FullScreenModalActions],

  mixins: [BaseMixin],

  init() {
    this.setState(Immutable.Map());
  },

  onHide(key) {
    this.setInStateAndTrigger(key, false);

    PopoverActions.hideGroup(key);

    /**
     * re-enable any active keybindings
     */
    keyBinder.enable();
  },

  onShow(key) {
    this.setInStateAndTrigger(key, true);

    /**
     * Disable any active keybindings temporarily while the modal is visible
     */
    keyBinder.disable();
  },
});
